import type {ComponentsLoaderPublicAPI} from '@wix/document-services-public-types'
import {componentsLoader} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (): PublicModuleDeclaration<ComponentsLoaderPublicAPI> {
    return {
        asyncInitMethod: componentsLoader.loadExternalComponentsForDS
    }
}
